<template>
  <div class="order">
    <appheader index="4"></appheader>
    <Search @searchOrder="searchOrder" :CommodityArr="CommodityArr" :allRemaining="allRemaining" />
    <div class="orderContent" v-loading="loading">
      <el-table :data="orderList" style="width: 100%" :header-cell-style="{ 'text-align': 'center' }" :cell-style="{ 'text-align': 'center' }">
        <el-table-column prop="type" label="类型" min-width="100"> </el-table-column>
        <el-table-column prop="orderNo" label="订单编号" min-width="220"> </el-table-column>
        <el-table-column prop="orgCode" label="网点编码" min-width="330"> </el-table-column>
        <el-table-column prop="operateTime" label="下单时间" min-width="220"> </el-table-column>
        <el-table-column property="" label="克重" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.goldWeigh">{{ scope.row.type == '来料加工' ? '+' : '-' }}{{ scope.row.goldWeigh }}g</span>
          </template>
        </el-table-column>
        <el-table-column prop="remaining" label="余料" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.remaining">{{ scope.row.remaining }}g</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <div class="box_fenye" v-if="orderList.length > 0">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="listQuery.current"
          :page-sizes="[10, 20, 40, 60, 100]"
          :page-size="listQuery.size"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import Appheader from '../moudel/Appheader';
import bottom from '../bady_bottom/bottom';
import Search from './components/Search.vue';
import { getMaterialDeliveryDetails } from '@/api/materialInventoryDetails';
import ls from '@/utils/localStorage';
export default {
  name: 'MaterialInventoryDetails',
  components: {
    Appheader,
    bottom,
    Search,
  },
  data() {
    return {
      CommodityArr: [
        {
          title: '全部',
          status: '',
        },
        {
          title: '来料',
          status: '来料',
        },
        {
          title: '下单',
          status: '下单',
        },
      ],
      listQuery: {
        size: 10,
        current: 1,
        type: '',
        orgCode: '',
      },
      loading: false,
      allRemaining: '',
      orderList: [],
      total: 0,
    };
  },
  mounted() {
    // 来料加工明细
    this.getMaterialDeliveryList();
  },
  methods: {
    fetchList() {
      // 来料加工明细
      this.getMaterialDeliveryList();
    },
    // 点击搜索
    searchOrder(searchCondition, status) {
      this.listQuery.current = 1;
      this.listQuery = { ...this.listQuery, ...searchCondition };
      this.listQuery.type = status;
      this.getMaterialDeliveryList();
    },
    // 获取列表
    getMaterialDeliveryList() {
      this.loading = true;
      getMaterialDeliveryDetails(this.listQuery)
        .then((res) => {
          this.orderList = res.data?.pageList?.records || [];
          this.allRemaining = res.data?.allRemaining;
          this.total = res.data.pageList?.total || 0;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 分页组件切换页数
    handleSizeChange(val) {
      this.listQuery.size = val;
      this.getMaterialDeliveryList();
    },
    // 外层分页组件切换
    handleCurrentChange(val) {
      this.listQuery.current = val;
      this.getMaterialDeliveryList();
    },
  },
  // 退出界面清除监听
  beforeDestroy() {},
};
</script>

<style scoped lang="scss">
.order {
  .orderContent {
    max-width: 1500px;
    margin: 0 auto;
    min-height: 700px;

    .subject {
      margin-bottom: 12px;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
      white-space: nowrap;
    }
  }
  .styleNumber-text {
    white-space: normal;
    padding-right: 10px;
  }
}

.orderHeader {
  display: flex;
  align-items: center;
  height: 50px;
  background: rgba(242, 242, 242, 1);
  padding-left: 6px;
}

.navBarWrap {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 999;
  max-width: 1494px;
}

.goods {
  display: flex;
  width: 230px;
}

.orderSpecifications {
  width: 270px;
  padding-right: 10px;
}

.orderLabel {
  width: 150px;
}

.ordrerNumber {
  width: 80px;
}
.ordrerStatus {
  width: 100px;
}

.orderReamrk {
  width: 100px;
}
.orderTotal {
  width: 210px;
}
.goodsRemark {
  width: 150px;
}

.orderAmount {
  width: 150px;
  margin-left: 20px;
}

.orderType {
  width: 80px;
  white-space: break-spaces;
}

.right {
  border-right: none;
}
/* 表格数据为空时显示——*/
.tableData :empty::before {
  content: '-';
}
</style>
<style>
.demo-tabletable-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

.box_fenye {
  max-width: 1500px;
  width: 100%;
  margin: 0 auto;
  margin-top: 68px;
  text-align: center;
  position: relative;
}

.box_fenye .el-pagination__total {
  line-height: 42px !important;
  color: #ec9368;
  font-size: 16px !important;
}

.box_fenye .el-pagination__jump {
  color: #ec9368;
  font-size: 16px;
}

.box_fenye .el-pagination__jump .el-input__inner {
  height: 42px !important;
  width: 40px;
}

.el-scrollbar__view .selected {
  color: #cdcdcd;
}

.el-scrollbar__view li {
  color: #ec9368;
}

.box_fenye .el-input__inner {
  width: 102px;
  height: 42px !important;
  border: 1px solid #cdcdcd;
  color: #ec9368;
  font-size: 16px !important;
}

.box_fenye .btn-next i::before {
  color: #ec9368;
  font-size: 16px;
  line-height: 42px;
}

.box_fenye .btn-prev i::before {
  color: #ec9368;
  font-size: 16px;
  line-height: 42px;
}

.box_fenye .active {
  color: #fff !important;
  background-color: #ec9368;
}

.box_fenye .el-pager li {
  color: #ec9368;
  width: 42px;
  height: 42px;
  line-height: 42px;
  font-size: 16px;
}

.box_fenye .el-pager li:hover {
  color: #fff;
  background-color: #ec9368;
}

.box_fenye .number {
  border: 1px solid #cdcdcd;
  margin: 0 2px;
}
</style>
